
import moment from "moment";
import ReactHTMLTableToExcel from "react-html-table-to-excel"


export const ExportDailyELEDataFetch = (props) => {
    const { ExcelData, name, WardName,
        ReadingFromDay,
        ReadingToDay,
        FinancialYear,
        Month
    } = props

    const days = Array.from({ length: 31 }, (_, i) =>
        String(i + 1).padStart(2, "0")
    );

    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-ExportDailyELEDataFetch"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export Excel"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-ExportDailyELEDataFetch" style={{ display: 'none', width: '48%' }}>

                <h5><span>&emsp;</span></h5>

                <tr style={{ border: '1px solid gray' }}>
                    <th colSpan={36} style={{ textAlign: 'center', fontSize: 16 }}>
                        {name}
                    </th>
                </tr>

                <tr>
                    <th colSpan={18} style={{ textAlign: 'center', fontSize: 16, border: '1px solid gray' }}>Financial Year = {FinancialYear ? FinancialYear : '-'}</th>
                    <th colSpan={18} style={{ textAlign: 'center', fontSize: 16, border: '1px solid gray' }}>Month = {Month ? Month : '-'}</th>
                </tr>

                <tr>
                    <th colSpan={12} style={{ textAlign: 'center', fontSize: 16, border: '1px solid gray' }}>Ward Name = {WardName ? WardName : '-'}</th>
                    <th colSpan={12} style={{ textAlign: 'center', fontSize: 16, border: '1px solid gray' }}>From Reading Day = {ReadingFromDay ? ReadingFromDay : '-'}</th>
                    <th colSpan={12} style={{ textAlign: 'center', fontSize: 16, border: '1px solid gray' }}>To Reading Day = {ReadingToDay ? ReadingToDay : '-'}</th>
                </tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white', borderTop: "1px solid black", verticalAlign: 'middle' }}>


                        <th className="sr_no_col" style={{ borderLeft: "1px solid black" }}>Sr.No</th>
                        {/* <th>Reading Date</th> */}
                        <th>Work Name</th>
                        <th>Mini Piller No.</th>
                        <th>Phase</th>
                        <th>Reading Time</th>

                        {days.map(day => (
                            <th key={day}>{day}</th>
                        ))}

                    </tr>
                </thead>

                <tbody>
                    {
                        ExcelData && ExcelData?.length > 0 ? ExcelData.map((pillar, pIndex) => {
                            const totalRows = pillar.phases.reduce(
                                (sum, ph) => sum + ph.records.length,
                                0
                            );

                            let pillarRendered = false;

                            return (
                                <>
                                    {pillar.phases.map((phase, phIndex) => {
                                        let phaseRendered = false;

                                        return phase.records.map((record, rIndex) => (
                                            <tr key={`${pIndex}-${phIndex}-${rIndex}`} style={{ verticalAlign: 'middle' }}>
                                                {/* Left fixed columns */}
                                                {!pillarRendered && (
                                                    <>
                                                        <td rowSpan={totalRows} align="center">{pIndex + 1}</td>
                                                        {/* <td rowSpan={totalRows} align="center">{pillar?.readingDay ? moment(pillar.readingDay).format('DD-MM-YYYY') : "-"}</td> */}
                                                        <td rowSpan={totalRows} align="center">{pillar?.workName || "-"}</td>
                                                        <td rowSpan={totalRows} align="center">{pillar?.miniPillarNo}</td>
                                                    </>
                                                )}

                                                {/* Phase column */}
                                                {!phaseRendered && (
                                                    <td rowSpan={phase.records.length} align="center">
                                                        {phase.phase}
                                                    </td>
                                                )}

                                                {/* Time */}
                                                <td>{record.time}</td>

                                                {/* Day values */}
                                                {days.map(day => (
                                                    <td key={day}>{record.days[day]}</td>
                                                ))}


                                                {pillarRendered = true}
                                                {phaseRendered = true}
                                            </tr>
                                        ));
                                    })}


                                </>
                            );
                        })
                            :
                            <tr>
                                <td colSpan={42}>No Data Found...</td>
                            </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}